// extracted by mini-css-extract-plugin
export default {"container":"HeroSection_container__xlNI1","title":"HeroSection_title__ANdgF","body":"HeroSection_body__TbTDk","header":"HeroSection_header__qDXrG"};